import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ManagementCardComponent } from "./management-card/management-card.component";
import { ManagementComponent } from "./management.component";
import { SharedModule } from "@shared/shared.module";

@NgModule({
  imports: [CommonModule, SharedModule, ManagementComponent, ManagementCardComponent],
})
export class ManagementModule {}
